//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { IConfiguration } from '@apis/tagged-by-curalate-automation/automationApiModels';
import { BodySecondaryText } from '@components/atoms/text/Text';
import { actions as streamDrawerActions } from '@streams/actions/streamDrawerActions';

const AutoActiveConfigRules = () => {
  const dispatch = useDispatch();

  const taggedByBvAutomationActiveConfiguration = useSelector(
    (state) =>
      state.streams.streamsDrawer.taggedByBvAutomationActiveConfiguration,
  ) as IConfiguration;

  const confLength =
    taggedByBvAutomationActiveConfiguration !== undefined
      ? Object.keys(taggedByBvAutomationActiveConfiguration).length
      : 0;

  if (confLength == 0) {
    dispatch(streamDrawerActions.fetchTaggedByBVAutomationConfigs()).catch(
      (err) => {
        console.log(err);
        throw err;
      },
    );
  }
  return (
    <TextWrapper>
      {confLength > 0 && (
        <TextContent>
          At 12:00 AM GMT, all pending content will be distributed to the
          galleries selected in the auto-distribution settings.
        </TextContent>
      )}
    </TextWrapper>
  );
};
const TextWrapper = styled.div(
  ({ theme }) => `
margin: ${theme.spacings[2]} ${theme.spacings[3]};
`,
);

const TextContent = styled(BodySecondaryText)`
  color: #5a5666;
  font-size: ${({ theme }) => theme.fontSizes[6]};
  padding: 5px;
`;
export default AutoActiveConfigRules;
